import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";
import axios from "axios";

// role - Get All (Read)
export const GetAll = createAsyncThunk(
  "Imperiality/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Imperiality}?term=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Get (Read)
export const GetSingle = createAsyncThunk(
  "Imperiality/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Imperiality}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// // role - Create (Add)
// export const Create = createAsyncThunk(
//   "Imperiality/create",

//   async (data, { rejectWithValue }) => {
//     console.log("this is called")
//     try {
//       const res = await POST(APIS.Imperiality, data);

//       console.log("resresresres",res)
//       return res; // The new role object
//     } catch (error) {
//       console.log(error, 'error');

//       return rejectWithValue(error);
//     }
//   }
// );

// role - Update

export const UploadImperiality = createAsyncThunk(
  "Imperiality/upload",
  async ({ id, formData }, { rejectWithValue }) => {
    console.log("🔥 UploadImperiality thunk called", id, formData);

    try {
      // Use your POST helper
      const res = await POST(`${APIS.Imperiality}/${id}`, formData);
      return res;
    } catch (error) {
      console.error("❌ UploadImperiality error", error);
      return rejectWithValue(error.response?.data || error);
    }
  },
);

// role - Delete
export const Delete = createAsyncThunk(
  "Imperiality/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Imperiality}/${id}`);
      return id; // Return the id of the deleted role
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Status
export const StatusRole = createAsyncThunk(
  "Imperiality/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Imperiality}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "imperiality",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UploadImperiality.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UploadImperiality.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })

      .addCase(UploadImperiality.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //   .addCase(UploadImperiality.pending, (state) => {
      //     state.status = IDS.SLICESTATUS.Loading;
      //   })
      //   .addCase(UploadImperiality.fulfilled, (state, action) => {
      //     state.status = IDS.SLICESTATUS.Succeeded;
      //     // state.data = action.payload;
      //     const index = state.data.findIndex(
      //       (role) => role.id === action.payload?.data?.id
      //     );
      //     if (index !== -1) {
      //       state.data[index] = action.payload.data;
      //     }
      //   })
      //   .addCase(UploadImperiality.rejected, (state, action) => {
      //     state.status = IDS.SLICESTATUS.Failed;
      //     state.error = action.payload;
      //   })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusRole.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusRole.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(StatusRole.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
